import { defineStore } from 'pinia'
import {to} from "await-to-js";
import {isEmpty, get, clone} from "lodash";
import {toRaw} from 'vue'
import { interceptor } from "@dutypay/utilities";

export const useCompanyStore = defineStore('companyStore', {
    state: () => {
        return {
            selectedCompany: {},
            companies: [],
            companiesCountTotal: null,
            companiesCountQuery: null,
            areCompaniesFetched: false
        }
    },
    getters: {
        hasCompanies: state => state.companiesCountTotal > 0,
        hasSelectedCompany: state => !isEmpty(toRaw(state.selectedCompany)),
    },
    actions: {
        async fetchCompanies(search = {}) {
            let err, fetchedCompanies,
            searchParameters = !isEmpty(search) ? '?search=' + get(search, 'query') : '';
            [err, fetchedCompanies] = await to(interceptor.get(`${process.env.VUE_APP_API_DUTYPAY}/api/v0/my/companies/all${searchParameters}`));
            if (err) {
                this.companies = [];
                this.companiesCountTotal = null;
                this.companiesCountQuery = null;
                this.areCompaniesFetched = false;
                throw err;
            }
            this.companies = fetchedCompanies.data.result.companies;
            this.companiesCountTotal = fetchedCompanies.data.result.companiesCountTotal;
            this.companiesCountQuery = fetchedCompanies.data.result.companiesCountQuery;
            this.areCompaniesFetched = true;
            if (this.companiesCountTotal === 1) {
                await this.switchCompany(this.companies[0]);
            }
        },
        async initCompanyStore() {
            let selectedCompany;
            try {
                selectedCompany = JSON.parse(localStorage.getItem("selectedCompany"));
            } catch {
                selectedCompany = {};
            }
            let hsCompanyId = get(selectedCompany, 'hs.company.id', undefined);
            if (!isEmpty(hsCompanyId)) {
                let err, company;
                [err, company] = await to(interceptor.get(`${process.env.VUE_APP_API_DUTYPAY}/api/v0/companies/${hsCompanyId}`));
                if (err) {
                    selectedCompany = {};
                    if (localStorage) {
                        localStorage.removeItem("selectedCompany");
                    }
                } else {
                    selectedCompany = company.data.result;
                }
            }
            this.selectedCompany = clone(selectedCompany);
            await this.fetchCompanies();
        },
        async switchCompany(companyObject) {
            let err, company;
            [err, company] = await to(interceptor.get(`${process.env.VUE_APP_API_DUTYPAY}/api/v0/companies/${get(companyObject, 'hs.company.id')}`));
            if (err) {
                this.selectedCompany = {}
                throw err;
            }
            this.selectedCompany = company.data.result;
            localStorage.setItem('selectedCompany', JSON.stringify(this.selectedCompany));
            return this.selectedCompany;
        },
    }
})